/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import MaterialTable from "material-table";
import { arrayOf, shape, string } from "prop-types";
import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export const Table = ({ 
  columns, 
  data, 
  actions, 
  title, 
  onRowClick, 
  style = null, 
  pageSize,
  ...rest 
}) => {
  const { t } = useTranslation();

  return (
    <MaterialTable
      style={style}
      icons={tableIcons}
      title={title}
      columns={columns}
      data={data}
      actions={actions}
      options={{
        search: false,
        toolbar: false,
        actionsColumnIndex: -1,
        headerStyle: {
          fontFamily: "AASmartSans",
          fontWeight: 400,
          fontSize: "1rem",
          marginLeft: "0",
          backgroundColor: "#031795",
          color: "#FFF",
        },
        rowStyle: rowData => ({
          fontFamily: "AASmartSans",
          fontWeight: 400,
          fontSize: "1rem",
          color: "#666666",
          boxShadow: "none",
          border: "none",
          backgroundColor: "#ffffff" 
        }),
        ...(pageSize && { pageSize }),
      }}
      localization={{
        body: {
          emptyDataSourceMessage: t("table.emptyDataSourceMessage")
        },
        header: {
          actions: "",
        },
        pagination: {
          labelRowsSelect: t("table.labelRowsSelect"),
          labelDisplayedRows: `{from}-{to} ${t("table.labelDisplayedRows")} {count}`,
          firstTooltip: t("table.firstTooltip"),
          previousTooltip: t("table.previousTooltip"),
          nextTooltip: t("table.nextTooltip"),
          lastTooltip: t("table.lastTooltip"),
          labelRowsPerPage: t("table.labelRowsPerPage"),
          firstAriaLabel: t("table.firstAriaLabel"),
          previousAriaLabel: t("table.previousAriaLabel"),
          nextAriaLabel: t("table.nextAriaLabel"),
          lastAriaLabel: t("table.lastAriaLabel"),
        },
      }}
      {...rest}
    />
  )
};

Table.propTypes = {
  columns: arrayOf(shape({ title: string, field: string })).isRequired,
  data: arrayOf(shape({})),
  title: string,
};

Table.defaultProps = {
  data: [],
  title: "",
};
